import { Component, OnInit, Input } from '@angular/core';

import { Notification } from './shared/notification.model'

@Component({
  selector: 'cm-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {

  @Input() notification: Notification

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/notification/notification.component.ts